import { TokenMetadata } from "../store/global/getTokenMetadata";
import { Token } from "../store/global/TokenEnum";
import { TOKEN_ICONS } from "../config/tokenIcons";
import * as Sentry from "@sentry/browser";

export const getTokenIcon = (symbol: Token, tokenMetadata: TokenMetadata | undefined): string => {
  const localTokenIcon = TOKEN_ICONS[symbol] ?? undefined;
  if (!tokenMetadata) {
    Sentry.captureMessage("Fallback to hardcoded token icons as tokenMetaData was undefined");
    if (localTokenIcon) {
      return localTokenIcon;
    } else {
      Sentry.captureMessage(`Couldn't find token icon in local token icons ${symbol}`);
      return "";
    }
  }

  const iconUrl = tokenMetadata[symbol]?.iconUrl;
  if (iconUrl) {
    return iconUrl;
  } else if (localTokenIcon) {
    Sentry.captureMessage(
      `Couldn't find token icon in tokenMetadata ${symbol}, using local token icon`
    );
    return localTokenIcon;
  } else {
    Sentry.captureMessage(
      `Couldn't find token icon in tokenMetadata AND local token icons ${symbol}`
    );
    return "";
  }
};
